<template>
  <img class="lazy-img" :class="{'fade-in': fade}" />
</template>

<script>
  export default {
    props: {
      fade: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss">
.lazy-img {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;

  z-index: -1;
}
</style>
